import React, { useState } from 'react';

const CareersSection = ({ onOpenConsultation }) => {
  const [selectedRole, setSelectedRole] = useState(null);

  const roles = [
    { title: 'Senior Full Stack Engineer (React/Node)', location: 'Remote / Hybrid', team: 'Core Products', type: 'Full-time' },
    { title: 'AI/ML Engineering Lead (PyTorch & LLMs)', location: 'Remote', team: 'AI Intelligence', type: 'Full-time' },
    { title: 'Senior Cloud DevOps Architect (AWS/K8s)', location: 'Remote', team: 'Infrastructure', type: 'Full-time' },
    { title: 'FinTech Solutions Architect', location: 'Hybrid', team: 'Lending Solutions', type: 'Full-time' },
  ];

  return (
    <section
      id="careers"
      style={{
        padding: '64px 0',
        position: 'relative',
        zIndex: 2,
        background: 'linear-gradient(180deg, #060816 0%, #0B0F24 100%)',
      }}
    >
      <div className="ht-container">
        {/* Section Header */}
        <div className="section-header">
          <span className="section-tag">CAREERS AT HUNGRY TOP</span>
          <h2 className="text-gradient">Build the Future of Enterprise Software</h2>
          <p>
            Join an elite engineering culture pushing the boundaries of AI, cloud platforms, and fintech innovation.
          </p>
        </div>

        {/* Roles List */}
        <div style={{ maxWidth: '900px', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {roles.map((role, idx) => (
            <div
              key={idx}
              className="glass-card"
              style={{
                padding: '24px 32px',
                borderRadius: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: '16px',
              }}
            >
              <div>
                <span style={{ fontSize: '0.75rem', color: '#00D4FF', fontWeight: 600, textTransform: 'uppercase' }}>
                  {role.team}
                </span>
                <h3 style={{ fontSize: '1.25rem', color: '#FFF', fontWeight: 700, margin: '4px 0' }}>
                  {role.title}
                </h3>
                <div style={{ display: 'flex', gap: '12px', color: '#A3A8B8', fontSize: '0.82rem' }}>
                  <span><i className="fas fa-map-marker-alt" style={{ marginRight: '4px', color: '#6C63FF' }}></i>{role.location}</span>
                  <span>•</span>
                  <span><i className="fas fa-clock" style={{ marginRight: '4px', color: '#8B5CF6' }}></i>{role.type}</span>
                </div>
              </div>

              <button
                onClick={() => setSelectedRole(role)}
                className="btn-secondary-glass"
                style={{ padding: '10px 20px', fontSize: '0.85rem' }}
              >
                Apply Now
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Role Application Modal */}
      {selectedRole && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 2000,
            background: 'rgba(6, 8, 22, 0.9)',
            backdropFilter: 'blur(16px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px',
          }}
        >
          <div
            className="glass-card"
            style={{
              maxWidth: '550px',
              width: '100%',
              padding: '36px',
              borderRadius: '24px',
              position: 'relative',
              border: '1px solid rgba(0, 212, 255, 0.4)',
            }}
          >
            <button
              onClick={() => setSelectedRole(null)}
              style={{
                position: 'absolute',
                top: '20px',
                right: '20px',
                background: 'rgba(255,255,255,0.1)',
                border: 'none',
                color: '#FFF',
                width: '36px',
                height: '36px',
                borderRadius: '50%',
                cursor: 'pointer',
              }}
            >
              <i className="fas fa-times"></i>
            </button>

            <span style={{ fontSize: '0.78rem', color: '#00D4FF', fontWeight: 700 }}>
              CAREER APPLICATION
            </span>
            <h3 style={{ fontSize: '1.5rem', color: '#FFF', margin: '6px 0 16px 0', fontWeight: 800 }}>
              Apply for {selectedRole.title}
            </h3>

            <form
              onSubmit={(e) => {
                e.preventDefault();
                alert(`Thank you for applying to Hungry Top Technologies! We have received your application for ${selectedRole.title}.`);
                setSelectedRole(null);
              }}
              style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}
            >
              <div>
                <label style={{ display: 'block', fontSize: '0.82rem', color: '#A3A8B8', marginBottom: '6px' }}>Full Name</label>
                <input
                  type="text"
                  required
                  placeholder="e.g. Sarah Jenkins"
                  style={{ width: '100%', padding: '12px 16px', borderRadius: '10px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.15)', color: '#FFF', fontSize: '0.9rem', outline: 'none' }}
                />
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '0.82rem', color: '#A3A8B8', marginBottom: '6px' }}>Email Address</label>
                <input
                  type="email"
                  required
                  placeholder="sarah@example.com"
                  style={{ width: '100%', padding: '12px 16px', borderRadius: '10px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.15)', color: '#FFF', fontSize: '0.9rem', outline: 'none' }}
                />
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '0.82rem', color: '#A3A8B8', marginBottom: '6px' }}>LinkedIn / Portfolio URL</label>
                <input
                  type="url"
                  required
                  placeholder="https://linkedin.com/in/username"
                  style={{ width: '100%', padding: '12px 16px', borderRadius: '10px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.15)', color: '#FFF', fontSize: '0.9rem', outline: 'none' }}
                />
              </div>

              <button type="submit" className="btn-primary-gradient" style={{ marginTop: '12px' }}>
                Submit Application
              </button>
            </form>
          </div>
        </div>
      )}
    </section>
  );
};

export default CareersSection;


